import {GenericModal} from "../../common/genericModal/GenericModal";
import s from "./ScoringAccuracyTipsModal.module.scss";
import {miscImages} from "../../../config/config";
import React from "react";
import Checkbox from "../../common/tools/Checkbox/Checkbox";
import ExternalLink from "../../common/ExternalLink";
import {useKeyboardConnectionHelp} from "../../onboarding/keyboardWizard/useKeyboardConnectionHelp.hook";

interface IScoringAccuracyTipsModalProps {
  isOpen: boolean;
  onClose: () => void;
  isDontShowAgainChecked: boolean;
  setIsDontShowAgainChecked: (isOptingIntoHideThisTip: boolean) => void;
}

export default function ScoringAccuracyTipsModal({onClose, isDontShowAgainChecked, setIsDontShowAgainChecked, isOpen}: IScoringAccuracyTipsModalProps) {
  const keyboardConnectionHelp = useKeyboardConnectionHelp();
  const height = 58;
  const width = 88;

  return (
    <GenericModal
      canShow={isOpen}
      backgroundColor={"white"}
      title={`Scoring accuracy tips`}
      maxWidth={`min(90vw, 600px)`}
      onClose={onClose}
    >
      <div className={s.modalBody}>
        <figure>
          <img src={miscImages.headphones} alt='' width={width} height={height}/>
          <figcaption>
            <h2>Use wired headphones</h2>
            Plug in wired headphones so the backing track plays only in your ears and isn’t picked up by your device’s microphone.<br/>
            <p className={s.note}>
              Some Bluetooth headphones, including AirPods, do not work for this purpose.
            </p>
          </figcaption>
        </figure>
        <figure>
          <img src={miscImages.backingTrackImage} alt='' width={width} height={height}/>
          <figcaption>
            <h2>Lower or mute the backing track</h2>
            If you’re not using headphones, turn the backing track volume down or off using the slider in the top right menu. This helps the microphone focus on your piano playing.
          </figcaption>
        </figure>
        <figure>
          <img src={miscImages.usbImage} alt='' width={width} height={height}/>
          <figcaption>
            <h2>Plug in for perfect accuracy</h2>
            For the most accurate scoring and real-time feedback, connect your keyboard via USB, MIDI, or Bluetooth.
            <ExternalLink url={keyboardConnectionHelp.supportLink} title={`Need a cable?`} />
          </figcaption>
        </figure>
        <Checkbox
          name={`hideThisTip`}
          isChecked={isDontShowAgainChecked}
          label={`Don't show this again`}
          onChange={(isChecked) => {
            setIsDontShowAgainChecked(isChecked);
          }}
        />
      </div>
    </GenericModal>
  );
}
